import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { colors } from '../../styles/designSystem';

// Sacred breathing animation
const breathe = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
`;

// Sacred rotation animation
const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Sacred pulse animation for dots
const pulse = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const LoadingContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
`;

const SpinnerContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  margin-bottom: 1rem;
`;

const OuterCircle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid ${colors.primary[100]};
  border-top: 3px solid ${colors.primary[500]};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

const InnerCircle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background: ${colors.primary[400]};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: ${breathe} 2s ease-in-out infinite;
`;

const DotsContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 1rem;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: ${colors.primary[400]};
  border-radius: 50%;
  animation: ${pulse} 1.4s ease-in-out infinite both;
  animation-delay: ${props => props.$delay || '0s'};
`;

const LoadingText = styled.p`
  color: ${colors.sacred.shadow};
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 1rem;
  text-align: center;
  letter-spacing: 0.025em;
`;

const LoadingSpinner = ({ message = "Loading sacred content..." }) => {
  return (
    <LoadingContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <SpinnerContainer>
        <OuterCircle />
        <InnerCircle />
      </SpinnerContainer>
      
      <DotsContainer>
        <Dot $delay="0s" />
        <Dot $delay="0.16s" />
        <Dot $delay="0.32s" />
      </DotsContainer>
      
      <LoadingText>{message}</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingSpinner; 
